import { render, staticRenderFns } from "./credentials.vue?vue&type=template&id=3266ccd6&lang=pug"
import script from "./credentials.vue?vue&type=script&lang=js"
export * from "./credentials.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports